import Moment from 'moment';
import { getAll, graphQL } from '../../api';
import { filter, getFilters } from '@/_store/utils/app/filter';
import { setFilterOptions } from '@/_store/utils/groups/setFilterOptions';
import { stringyObject } from '../utils/helpers';
import {
  createPaginatedRequest,
  createFilterParam,
} from '../utils/app/paginatedRequestBuilder';
import { callString, filterParams } from '../utils/groups/requestConfig';

const state = {
  dataset: [],
  lastEvalKey: 1,
  createGroup: false, // modal boolean
  newGroup: {
    group_name: '', // set
    // club_friendly_name: "", // shark
    address: {
      address_1: '', // set
      address_2: '', // set
      city: '', // set
      state: '', // set
      zip: '', // set
      country: 'USA',
    },
    tablet_settings: {
      brightness_day_level: 80, // set
      brightness_day_time: '07:00', // set
      brightness_night_level: 50, // set
      brightness_off_time: '21:00', // set
      brightness_use: false, // set
      notification_emails: [],
      notification_frequency: 7,
      screenshot_frequency: 5, // set
      send_offline_report: false, // set
      take_screenshots: false, // set
      warning_trigger: 20, // set
      danger_trigger: 3,
      offline_duration: '7',
    },
    contact: {
      email: '',
      contact_name: '',
      phone: '',
    },
    interface: '', // set
    // ad_schedule: "", //set
    inventory: '0',
    last_activity: new Moment().format('X'), // .format('YYYY-MM-DDTHH:MM:SSZ'), //set
    // site_id: "", // Shark
    // gpsiServer "", //shark
    // price: "", // Bazzbi
    // area_id: "", // Bazzbi, Avis
  },
  queryParams: {
    page: 1,
    search: '',
  },
  loading: false,
  groupCreate: null,
  export: false, // modal boolean
  exportURL: {
    csv: '',
    excel: '',
    loaded: false,
  },
};

const getters = {
  getDataset(state) {
    return state.dataset;
  },
  getQueryParams(state) {
    return state.queryParams;
  },
  getCreateGroup(state) {
    return state.createGroup;
  },
  getExport(state) {
    return state.export;
  },
  getGroupCreate(state) {
    return state.groupCreate;
  },
  getExportURL(state) {
    return state.exportURL;
  },
  getNewGroup(state) {
    return state.newGroup;
  },
  getLastEvalKey(state) {
    return state.lastEvalKey;
  },
  getLoading(state) {
    return state.loading;
  },
};

const actions = {
  acquireGroups: async ({ commit, rootGetters, dispatch }, payload) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      const client = rootGetters['account/getCurrentClient'].client_name;
      if (client === 'shark') {
        dispatch('acquireSharkGroups', payload);
        resolve();
      } else {
        createPaginatedRequest(
          filterParams,
          callString(),
          'group',
          payload.paginate
        )
          .then(res => {
            commit('setDataset', res.data.data.getPaginated.items);
            commit(
              'setLastEvalKey',
              res.data.data.getPaginated.attr.LastEvaluatedKey
            );
            setFilterOptions(res.data.data.getPaginated.items);
            commit('setLoading', false);
            resolve(res);
          })
          .catch(err => {
            commit('setLoading', false);
            reject(err);
          });
      }
    });
  },
  acquireSharkGroups: async ({ commit, getters }, payload) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      const filters = getFilters();
      const search = filters.search ? filters.search : '';

      let page;
      if (payload.paginate) {
        page = getters.getLastEvalKey + 1;
        commit('setLastEvalKey', page);
      } else {
        page = getters.getLastEvalKey;
      }

      const { variables } = createFilterParam(filterParams);

      const orderBy = payload.sortBy ? payload.sortBy : 'last_activity';
      const sortDir =
        payload.sortDesc && payload.sortDesc[0] === false ? 'ASC' : 'DESC';

      graphQL({
        query: `
            query {
              getAllGroups(
                itemsPerPage: ${payload.itemsPerPage}
                page: ${payload.page}
                sortBy: "${orderBy}"
                sortDir: "${sortDir}"
                search: "${search}"
                filter: ${variables}
              ) ${callString()}
            }
          `,
      })
        .then(res => {
          commit('setDataset', res.data.data.getAllGroups);

          setFilterOptions(res.data.data.getAllGroups);
          commit('setLoading', false);
          resolve(res);
        })
        .catch(err => {
          commit('setLoading', false);
          reject(err);
        });
    });
  },
  createGroup: async ({ commit, rootGetters, dispatch, getters }) => new Promise((resolve, reject) => {
    let newGroup = getters.getNewGroup;
    const client = rootGetters['account/getCurrentClient'].client_name;
    if (client === 'avis') {
      newGroup.home_base = false;
    }
    if (client === 'bazzbi') {
      newGroup.price = 1.0;
    }
    newGroup.tablet_settings.notification_emails = JSON.stringify([
      newGroup.contact.email,
    ]);

    newGroup = stringyObject(newGroup);
    const clientTable = rootGetters['account/getCurrentClient'].table_name;
    getAll(
      `/group?query=${encodeURIComponent(
        `mutation{create(type_name: "group", 
            group: ${newGroup}, 
            table_name:"${clientTable}", 
          ){ 
            group_name, 
            error, 
            success 
          }}`
      )}`
    )
      .then(res => {
        commit('setGroupCreate', 'New Group Created');
        dispatch('acquireGroups');
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  }),
  exportReport: async ({ commit, rootGetters }, payload) => new Promise((resolve, reject) => {
    const user_groups =
        rootGetters['account/getCurrentUser'].group_id &&
        rootGetters['account/getCurrentUser'].group_id[0];
    let group;
    if (user_groups && user_groups !== 'all') {
      group = { uuid: user_groups };
      group = stringyObject(group);
    }
    const cols = [];
    if (payload.name) {
      cols.push({ id: 'group_name', title: 'Name' });
    }
    if (payload.interface) {
      cols.push({ id: 'interface', title: 'Interface' });
    }
    if (payload.ad_schedule) {
      cols.push({ id: 'ad_schedule', title: 'Ad Schedule' });
    }
    if (payload.area) {
      cols.push({ id: 'area_id', title: 'Area' });
    }
    if (payload.city) {
      cols.push({ id: 'city', title: 'City' });
    }
    if (payload.status) {
      cols.push({ id: 'status', title: 'Active/Inactive' });
    }

    const filterParams = [
      'interface',
      'area_id',
      'city',
      'ad_schedule',
      'status',
    ];
    let variables = filter(filterParams);
    variables.type_name = 'group';

    // const search = createSearch('group_name');
    const clientTable = rootGetters['account/getCurrentClient'].table_name;

    variables = stringyObject(variables);
    cols = stringyObject(cols);
    const callString = `{
        csv,
        excel,
        success
      }`;
    let query = `{export(    
        csv: ${payload.csv}, 
        excel: ${payload.excel}, 
        filters: ${variables},
        cols: ${cols}, 
        type_name: "group", 
        table_name:"${clientTable}",`;
    if (group) {
      query = query.concat(`group: ${group},`);
    } else {
      query = query.concat('index: "all-index",');
    }
    query = query.concat(`)${callString}}`);
    getAll(`/group?query=${encodeURIComponent(query)}`)
      .then(res => {
        commit('setExportURL', {
          csv: res.data.data.export.csv,
          excel: res.data.data.export.excel,
          loaded: true,
        });
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  }),
};

const mutations = {
  setDataset(state, payload) {
    state.dataset = payload;
  },
  setQueryParams(state, payload) {
    state.queryParams = payload;
  },
  setCreateGroup(state, payload) {
    state.createGroup = payload;
  },
  setGroupCreate(state, payload) {
    state.groupCreate = payload;
  },
  setExport(state, payload) {
    state.export = payload;
  },
  setExportURL(state, payload) {
    state.exportURL = payload;
  },
  setNewGroup(state, payload) {
    state.newGroup = payload;
  },
  setLastEvalKey(state, payload) {
    state.lastEvalKey = payload;
  },
  setLoading(state, payload) {
    state.loading = payload;
  },
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
